import ScalarIconCopy_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCopy.vue.script.js";
//#region src/components/ScalarIconCopy.vue
var ScalarIconCopy_default = ScalarIconCopy_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCopy_default as default };

//# sourceMappingURL=ScalarIconCopy.js.map